// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_d75b9b55"};